module.exports = "<app-header [currentTab]=\"currentTab\"></app-header>\n<router-outlet></router-outlet>\n\n"